import React from 'react';
import './confirm-profile.scss';
import AuthenticateAPI from '../../apis/authenticate'
import ToasterComponent from '../common/cw-toaster-component/cw-toaster-component';
import Header from '../common/header/header-component';
import SchoolProfile from '../school/add-school/add-school'
import Path from '../routes/routes-path';
import StaffProfile from './staff-profile/staff-profile'
import SessionCache from '../routes/session-cache';

class ConfirmProfile extends React.Component {
    state = {
    }

    constructor() {
        super()
        this.getStaffInfo()
    }

    getStaffInfo() {
        let user = SessionCache.getUser()
        let isAdmin = user.types.some(item => item.type == "ADMIN")
        if (isAdmin) {
            this.state.isAdmin = isAdmin
            this.state.schoolProfileConfirmed = user.schoolInfo?.isConfirmed
            this.state.userProfileUpdated = user.profileUpdated
        } else {
            this.state.userProfileUpdated = user.profileUpdated

        }
    }

    showToaster(type, message) {
        this.setState({
            showToaster: true,
            toasterMessage: message,
            toasterType: type
        }, () => {
            setTimeout(() => { this.hideToaster() }, 3000);
        });
    }

    hideToaster() {
        this.setState({
            showToaster: false
        });
    }

    onSave = () => {
        this.showToaster("success", "Profile Updated");
        setTimeout(() => { this.props.history.replace(Path.DASHBOARD) }, 2000)
    }

    onAlreadyConfirmed = () => {
        this.props.history.replace(Path.DASHBOARD)
    }

    render() {
        return (
            <div>
                <Header from={'VERIFY_SCREEN'}></Header>
                <div className="confirm-profile">
                    {
                        this.state.isAdmin && !this.state.schoolProfileConfirmed ? <SchoolProfile disableBack={true} headerTitle="Please confirm your details" checkAlreadyConfirmed={this.onAlreadyConfirmed} onSave={this.onSave} />
                            :
                            !this.state.userProfileUpdated ?
                                <StaffProfile headerTitle="Please confirm your details" onSave={this.onSave} />
                                :
                                this.onAlreadyConfirmed()
                    }

                </div >
                {this.state.showToaster ? <ToasterComponent message={this.state.toasterMessage} type={this.state.toasterType} /> : ""}
            </div >
        );
    }
}

export default ConfirmProfile;